import React, { useState } from "react";
import Editor from "../../../../partials/Editor";

const UpdateNoteForm = ({ onSubmit, onCancel, item = null }) => {
    const [model, setModel] = useState(item);

    const onChange = (idx, key, value) => {
        if (key && value) {
            let _model = { ...model };
            _model.notes[idx][key] = value;
            setModel(_model);
        }
    };

    return (
        <form
            method="POST"
            onSubmit={(event) => {
                event.preventDefault();
                onSubmit({
                    note: model.notes[0].note,
                    summary: model.notes[0].summary,
                    noteId: model.notes[0].noteId,
                });
            }}
        >
            <div className="form-group">
                <label htmlFor="summary-id">Summary</label>
                <input
                    type="text"
                    onChange={({ currentTarget }) => onChange(0, "summary", currentTarget.value)}
                    className="form-control input-height"
                    id="summary-id"
                    required
                    defaultValue={model.notes[0].summary}
                    aria-describedby="summary-id"
                    placeholder="enter summary"
                />
            </div>

            <div className="form-group">
                <Editor content={model.notes[0].note} placeholder="enter noter here" onChange={(data) => onChange(0, "note", data)} />
                <small id="note" className="form-text text-muted">
                    Clinical Note/Plan Note
                </small>
            </div>

            <div className="text-center">
                <button type="button" onClick={onCancel} className="mdl-button mdl-button--raised mdl-js-ripple-effect m-l-10 margin-right-10 btn-circle btn-default">
                    <i className="material-icons text-danger">cancel</i> Cancel
                </button>

                <button type="submit" className="mdl-button mdl-button--raised mdl-js-ripple-effect m-l-10  btn-circle btn-success">
                    Update Note <i className="material-icons">arrow_right_alt</i>
                </button>
            </div>
        </form>
    );
};

export default UpdateNoteForm;
